angular
    .module('eficienciaFiscalModule')
    .component('efdAlertaNfe', {
        transclude: true,
        bindings: {
            chave: '<',
            numero: '<',
            emissao: '<',
            emissaoPropria: '<',
            participante: '<'
        },
        template: `
            <div class="well well-xs efd-alertas">
                <div class="dados-nota-fiscal">
                    <div class="labeled-info">
                        <b>CHAVE</b>
                        <br/>
                        <span ng-show="$ctrl.chave">{{$ctrl.chave}}</span>
                        <span ng-hide="$ctrl.chave">Não informado</span>
                    </div>
                    <div class="labeled-info numero-nfe">
                        <b>NÚMERO</b>
                        <br/>
                        <span>{{$ctrl.numero}}</span>
                    </div>
                    <div class="labeled-info">
                        <b>DATA DE EMISSÃO</b>
                        <br/>
                        <span>{{$ctrl.emissao | date: 'dd MMM yyyy'}}</span>
                    </div>
                    <div class="labeled-info">
                        <b ng-hide="$ctrl.emissaoPropria">EMITENTE</b>
                        <b ng-show="$ctrl.emissaoPropria">DESTINATÁRIO</b>
                        <br/>
                        <span>
                            {{$ctrl.participante.nome | limitToDots: 50}} - 
                            <small class="text-muted">{{$ctrl.participante.cpfCnpj | cpfCnpj}}</small>
                        </span>
                    </div>
                </div>
                <ng-transclude></ng-transclude>
            </div>
        `
    })
